module.exports = __webpack_public_path__ + "media/Digrab_Showreel.3bef02e0.webm";